const isDebugEnabled =
  process.env.NODE_ENV !== 'production' || process.env.VUE_APP_DEBUG_LOGS === 'true';

export const debugLog = (...args) => {
  if (isDebugEnabled) console.log(...args);
};

export const debugInfo = (...args) => {
  if (isDebugEnabled) console.info(...args);
};

export const debugWarn = (...args) => {
  if (isDebugEnabled) console.warn(...args);
};

export const reportError = (...args) => {
  console.error(...args);
};
